<template>
  <div class="h-100">
       <Horizontal :currentpoll="currentpoll" v-if="!error" /> 
       <div class="text-danger bg-dark text-center p-1" v-else>
         An error occured with Vote Now browser source.
       </div>
  </div>
</template>

<script>
import { EventBus } from '@/event-bus';
// import Standard from '@/components/themes/Standard'
import Horizontal from '@/components/themes/Horizontal'
export default {
  created() {
    var self = this
    if(this.$route.params.channel){
      if(isNaN(this.$route.params.channel)){
        //convert
        axios.get(`https://api.twitch.tv/helix/users`, {
          params: {
            'login': self.$route.params.channel
          },
          headers: {
            'Client-ID' : 'iax11orzq0qyu4cuebmstnn530856g'
          }
        })
        .then(function (response) {
          if(response.data.data.length){
            self.channel_id = response.data.data[0].id
            self.getFirebaseData()
          }else{
            self.error = true
          }
        })

      }else{
        this.channel_id = this.$route.params.channel
        this.getFirebaseData()
      }
      
    }else{
      this.error = true
    }
    
  },
  components: {
    Horizontal
  },
  data () {
    return {
      error: false,
      channel_id: null,
      show_string_minimize: false,
      ActivePollVisible: true,
      showbuttonVisible: true,
      platform: 'browsersource',
      uid: null,
      polltimestamp: 0,
      uservoted: false,
      currentpoll: null,
      totalvotes: 0,
      timetovote: 0,
      countdownEnd: false,
      PollCreatedAt: 0,
      timeover: false,
      pollhidden: false,
      loaded: false,
    }
  },
  methods: {
    getFirebaseData(){
      // console.log('twitch_authenticated, loading Firebase')
      let self = this
      if(!this.channel_id) return this.error = true
      db.ref(`polls/channel-${this.channel_id}`).on('value', function(snapshot) {
        self.loaded=true
        self.currentpoll = snapshot.val()
        //if new poll
        if(self.currentpoll){
          if(self.PollCreatedAt!==snapshot.val().created_at && snapshot.val().created_at!==0){
            self.PollCreatedAt = self.currentpoll.created_at
            self.uservoted=false
            self.pollhidden=false
            self.polltimestamp = Date.now()
            self.timetovote = self.currentpoll.timetovote*1000
            self.checkIfTimeOver()
            //start timer
            self.startCountdown()
          }
            
          
          //set totalvotes
          self.totalvotes=0
            _.forEach(self.currentpoll.results, function(value) {
              self.totalvotes += value.votes;
            });
        }

      });

    },
    checkIfTimeOver(){
      if(this.currentpoll.created_at+(this.currentpoll.timetovote*1000)<=Date.now()){
        //time over
        this.timeover = true
      }else{
        this.timeover = false
        //remainig time
        this.timetovote = this.currentpoll.created_at+(this.currentpoll.timetovote*1000)-Date.now()
      }
    },
    getvotespercent(number){
      if(number === 0){
        if(this.totalvotes==0 && !this.timeover){ //show loading
          return 100
        }
        return 0
      }
      return (number/this.totalvotes*100).toFixed(2);
    },
    startCountdown(){
    //   let self = this
    //   var width = 1
    //   var id = setInterval(frame, 10);
    //   function frame() {
    //       if (width >= 100) {
    //           clearInterval(id);
    //       } else {
    //           width++; 
    //           self.timetovote = width + '%'; 
    //       }
    //   }
      this.countdownEnd=false
      
      // this.$refs.countdown.start();
    },
    countdownVotingEnd(){
      this.countdownEnd=true
      this.timeover=true
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/BrowserSource.vue